import React, { ReactNode } from 'react';
import { getClassNames } from 'utils';
import './PageVariantWrapper.css';

const PageVariantWrapper = ({
    className = '',
    children = null,
} : {className?: string; children: ReactNode}) => (
    <div className={getClassNames('PageVariant main', className)}>
        {children}
    </div>
);

export default PageVariantWrapper;
